const primaryNavAnimationNames = {
  SLIDE_IN_FROM_LEFT: 'activeNavSlideInFromLeft',
  SLIDE_IN_FROM_RIGHT: 'activeNavSlideInFromRight',
  SLIDE_OUT_TO_LEFT: 'activeNavSlideOutLeft',
  SLIDE_OUT_TO_RIGHT: 'activeNavSlideOutRight',
};

export default primaryNavAnimationNames;
